export const normal_date_convert = data => new Date(data).toDateString();
